import { graphql } from 'react-relay';

export const UPDATE_PROMOTIONAL_CODE_MUTATION = graphql`
  mutation UpdatePromotionalCodeMutation($input: UpdatePromotionalCodeInput!) {
    UpdatePromotionalCode(input: $input) {
      id
      code
      plan
      planName
      planValueCents
      discountType
      discountValue
      discountDuration
      durationMonths
      appliesTo
      isActive
      maxUses
      currentUses
      expiresAt
      createdAt
    }
  }
`;
